module.exports = __webpack_public_path__ + "media/images/contest-menu-label@2x-2aec4f380a1b74702399007146ce53a9.png";